import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrash as faTrashRegular } from "@fortawesome/pro-regular-svg-icons"
import { faTrash as faTrashSolid } from "@fortawesome/free-solid-svg-icons"
import "./DeleteButton.css"

/**
 * Reusable delete button for the curriculum editor view
 * @param {Function} onClick - runs when the button is clicked
 * @param {boolean} disable - whether to disable the button
 * @param {string} className - css class used for any custom styles
 * @returns {JSX.Element}
 */
const DeleteButton = ({ onClick = () => null, disabled = false, className = "" }) => {
  const handleDelete = disabled ? () => null : onClick

  return (
    <button className={`curriculum-delete-button ${className}`} onClick={handleDelete} disabled={disabled}>
      <FontAwesomeIcon icon={faTrashRegular} className={disabled ? "show-always" : "show-by-default"} />
      {!disabled && <FontAwesomeIcon icon={faTrashSolid} className="show-on-hover" />}
    </button>
  )
}

export default DeleteButton
